/**
 * Los videos de las sesiones viven en Vimeo, pero el campo `video` no guarda un
 * formato único: a veces es la URL completa, a veces sólo el ID numérico.
 * Portado de `recnet-24/app/screens/Sesion/index.js:32`.
 */
export function extraerIdVimeo(video) {
  if (!video) return null;

  const texto = String(video).trim();

  const enUrl = texto.match(/(?:vimeo\.com\/|vimeo\.com\/video\/|player\.vimeo\.com\/video\/)(\d+)/);
  if (enUrl) return enUrl[1];

  if (/^\d+$/.test(texto)) return texto;

  return null;
}

/**
 * URL para incrustar en un iframe. `dnt=1` le pide a Vimeo que no rastree al
 * espectador: es contenido de miembros, no hace falta perfilarlos.
 */
export function urlIncrustadaVimeo(video) {
  const id = extraerIdVimeo(video);
  return id ? `https://player.vimeo.com/video/${id}?dnt=1` : null;
}
